/**
 * Category Ownership + Sentiment — same formulas as VisibilityTab / ConsiderationTab.
 */

function queryDetails(query) {
  const visibilityMetrics = query?.scores?.visibility_metrics || {}
  const aiRankingPosition = Number(visibilityMetrics.ai_ranking_position) || 0
  const aiRankings = query?.scores?.ai_rankings || []
  const isBrandRanked = aiRankings.some((r) => r.primary === true)
  const totalRankings = aiRankings.length || 0
  const considerationMetrics = query?.scores?.consideration_metrics || query?.scores?.consideration || {}
  const sentiment = typeof considerationMetrics === 'object' ? considerationMetrics.sentiment : null
  return { aiRankingPosition, isBrandRanked, totalRankings, sentiment }
}

export function computeCategoryOwnershipScore(queries = []) {
  if (!queries.length) return null

  const details = queries.map(queryDetails)
  const MIN_PENALTY_POSITION = 10

  const penalizedAvg = details.reduce((acc, q) => {
    if (q.aiRankingPosition > 0) return acc + q.aiRankingPosition
    const penalty = q.totalRankings > 0
      ? Math.max(q.totalRankings + 1, MIN_PENALTY_POSITION)
      : MIN_PENALTY_POSITION
    return acc + penalty
  }, 0) / details.length

  const aiRankingScore = penalizedAvg === 0
    ? 0
    : Math.max(0, 100 - (penalizedAvg - 1) * 10)

  const withBrand = details.filter((q) => q.isBrandRanked).length
  const shareOfVoice = Math.round((withBrand / details.length) * 100)

  return Math.round((0.6 * aiRankingScore) + (0.4 * shareOfVoice))
}

/** Tone of Summary Score: ((avg sentiment + 1) / 2) * 100 */
export function computeSentimentScore(queries = []) {
  if (!queries.length) return null

  const sentiments = queries.map((q) => {
    const value = queryDetails(q).sentiment
    const n = Number(value)
    return Number.isFinite(n) ? n : 0
  })

  const tone = sentiments.reduce((sum, s) => sum + s, 0) / sentiments.length
  return Math.round(((tone + 1) / 2) * 100)
}
